import * as React from 'react';
import { Industry } from '../../Model/Industry';
import { Trans } from '../Trans';
import { AbstractModelSelectBox } from './AbstractModelSelectBox';

export class IndustrySelectBox extends AbstractModelSelectBox<Industry> {
    protected getOptionProperty(): string {
        return 'industry';
    }

    protected renderLabel() {
        return <>
            <span className="sr-only"><Trans>Bereich</Trans></span>
            <i className="fas fa-chart-pie"/>
            {this.props.children}
        </>;
    }
}
